// Site-wide content shared by the header, footer and pages
export const SITE = {
  name: 'Turn 10 Racing',
  founder: 'Saverio H Striglia III',
  location: 'Palm City, FL',
  established: 2024,
  // TODO: switch to webcontact@turn10racing.com once the mailbox is set up
  contactEmail: 'saverio@striglia.net',
  instagramUrl: 'https://www.instagram.com/strigs_racer',
  instagramHandle: '@strigs_racer',
  poweredBy: {
    name: 'Striglia Enterprises',
    url: 'https://striglia.net',
  },
};

export const NAV_LINKS = [
  { title: 'Home', to: '/' },
  { title: 'About Us', to: '/about' },
  { title: 'Driver Training', to: '/driver-training' },
  { title: 'Our Shop', to: '/our-shop' },
  { title: 'Gallery', to: '/gallery' },
  { title: 'Contact', to: '/contact' },
];

export const WRL_2026_TRACKS = [
  'Barber Motorsports Park',
  'Road America',
  'Daytona',
  'Road Atlanta',
  'Watkins Glen',
  'Sebring',
  'COTA',
];

export const WRL_2027_SCHEDULE = [
  { track: 'Eagles Canyon, TX', dates: 'Feb 05 – Feb 08' },
  { track: 'Barber Motorsports Park, AL', dates: 'Feb 26 – Mar 01' },
  { track: 'Thunder Hill Raceway Park, CA', dates: 'Apr 02 – Apr 05' },
  { track: 'Road America, WI', dates: 'Apr 30 – May 03' },
  { track: 'Daytona International Speedway, FL', dates: 'Jun 04 – Jun 06' },
  { track: 'Road Atlanta, GA', dates: 'Jul 23 – Jul 26' },
  { track: 'Watkins Glen International, NY', dates: 'Aug 20 – Aug 23' },
  { track: 'Utah Motorsports Campus, UT', dates: 'Sep 17 – Sep 20' },
  { track: 'Sebring International Raceway, FL', dates: 'Oct 15 – Oct 18' },
  { track: 'Circuit Of The Americas, TX', dates: 'Dec 02 – Dec 04' },
];
